#@import Booking.Views.PickerCollection
#@import Booking.Views.PartySize
#@export Booking.Views.PartySizes

class Booking.Views.PartySizes extends Booking.Views.PickerCollection

  templateName: 'partysizes'

  childView: Booking.Views.PartySize
